import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Spin } from 'antd';
import Slider from 'react-slick';

import MarketSliderCard from '../../components/MarketSliderCard/MarketSliderCard';
import NotifyMeModal from '../../components/NotifyMeModal/NotifyMeModal';
import useMediaQuery from '../../Hooks/useMediaQuery';
import useQuickBuyOrder from '../../Hooks/useQuickBuyOrder';
import useQuickBuySecondary from '../../Hooks/useQuickBuySecondary';
import TradeDrawer from '../../pages/PropertyListing/TradeDrawer';
import TradeModal from '../../pages/PropertyListing/TradeModal';
import QuickBuyInitial from '../QuickBuyInitialOffering/QuickBuyInitial';
import QuickBuyInitialDrawer from '../QuickBuyInitialOffering/QuickBuyInitialDrawer';

import { ChevronLeft, ChevronRight } from '../../assets/icons';

import { updateFavoriteCount } from '../../store/reducer/favoriteSlice';
import { addOrRemoveToFavouriteAction, updateInitialPropertyList } from '../../store/reducer/initialOfferingSlice';
import { notifyMeForProperty } from '../../store/reducer/notifyMeSlice';
import { fetchSecondaryOfferingListAction, updateSecondaryPropertyList } from '../../store/reducer/secondaryOfferingSlice';
import { maxShareCalculator, maxShareCalculatorWithNoOfShare } from '../../utils/maxShareCalculator';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';

import './MarketSlider.scss';
import { debounce } from 'lodash';
import { GHOST_NOTIFY, PRIMARY_BUTTON_BUY, PRIMARY_PROPERTY_LABELS, TOOLTIP_TEXT } from '../../utils/constant';

const MarketSlider = (props) => {
  const { initialOfferingData, secondaryMarketData, initialLoading, isSecondary, secondaryLoading, onLoadMore, hasMore, loadingMore } = props;
  const [openQuickBuy, setOpenQuickBuy] = useState('');
  const [openQuickBuySecondary, setOpenQuickBuySecondary] = useState('');
  const [open, setOpen] = useState(false);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [prevDisabled, setPrevDisabled] = useState(true);
  const [quickBuyPropertyData, setQuickBuyPropertyData] = useState();
  const [isParentSlid, setIsParentSlid] = useState(true);
  const [isChildrenSlide, setIschildrenSlide] = useState(true);
  const [isCHangeChildCondition, setIsChangeChildCondition] = useState(true);
  const [email, setEmail] = useState('');
  const [newsLetterChecked, setNewsLetterChecked] = useState(false);
  const [storeNotifyMeData, setStoreNotifyMeData] = useState({});
  const [slideParentSlide, setSlideParentSlide] = useState(false);
  const [notifyLoadingId, setNotifyLoadingId] = useState(0);
  const [initialArrowHide, setInitialArrowHide] = useState(false);
  const [secondaryArrowHide, setSecondaryArrowHide] = useState(false);

  const dispatch = useDispatch();
  const userProfileData = useSelector((state) => state.userData.userData);
  const formRef = useRef();
  let navigate = useNavigate();
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const quickByOptions = useQuickBuyOrder(setOpenQuickBuy, quickBuyPropertyData);
  const quickBuySecondaryOptions = useQuickBuySecondary(setOpenQuickBuySecondary, quickBuyPropertyData, {});
  const slider = useRef();

  const handleNextDIsabled = (totalNumberOfCard, leftMostCard, slideToShow) => {
    setNextDisabled(leftMostCard + slideToShow >= totalNumberOfCard);
    setPrevDisabled(leftMostCard === 0);
  };

  const handleArrowHide = (totalNumberOfCard, leftMostCard, slideToShow, isSecondary) => {
    if (isSecondary) {
      setInitialArrowHide(leftMostCard + slideToShow >= totalNumberOfCard);
    } else {
      setSecondaryArrowHide(leftMostCard + slideToShow >= totalNumberOfCard);
    }
  };

  // When new items are appended (after a load-more), re-enable the right arrow
  // so the user can scroll into the newly loaded cards.
  useEffect(() => {
    if (!isSecondary) setNextDisabled(false);
  }, [initialOfferingData?.data?.properties?.length]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isSecondary) setNextDisabled(false);
  }, [secondaryMarketData?.data?.properties?.length]); // eslint-disable-line react-hooks/exhaustive-deps

  // Trigger load-more when the user scrolls within one screen-width of the end.
  const checkLoadMore = (totalNumberOfCard, leftMostCard, slideToShow) => {
    if (leftMostCard + slideToShow * 2 >= totalNumberOfCard && hasMore && !loadingMore) {
      onLoadMore?.();
    }
  };

  useEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, [initialOfferingData, secondaryMarketData]);

  const updateSize = () => {
    if (window.innerWidth <= 2200 && window.innerWidth > 1930) {
      handleArrowHide(initialOfferingData?.data?.properties?.length, 0, 5, false);
      handleArrowHide(secondaryMarketData?.data?.properties?.length, 0, 5, true);
    }
    if (window.innerWidth <= 1930 && window.innerWidth > 1600) {
      handleArrowHide(initialOfferingData?.data?.properties?.length, 0, 4, false);
      handleArrowHide(secondaryMarketData?.data?.properties?.length, 0, 4, true);
    }
    if (window.innerWidth <= 1600 && window.innerWidth > 999) {
      handleArrowHide(initialOfferingData?.data?.properties?.length, 0, 3, false);
      handleArrowHide(secondaryMarketData?.data?.properties?.length, 0, 3, true);
    }
    if (window.innerWidth <= 999 && window.innerWidth > 640) {
      handleArrowHide(initialOfferingData?.data?.properties?.length, 0, 2, false);
      handleArrowHide(secondaryMarketData?.data?.properties?.length, 0, 2, true);
    }
    if (window.innerWidth <= 640 && window.innerWidth > 639) {
      handleArrowHide(initialOfferingData?.data?.properties?.length, 0, 2, false);
      handleArrowHide(secondaryMarketData?.data?.properties?.length, 0, 2, true);
    }
  };

  const afterSlideChange = useCallback(
    debounce(() => {
      setIschildrenSlide(true);
      setSlideParentSlide(false);
    }, 500),
    [],
  );

  const inslider = {
    dots: false,
    infinite: false,
    speed: 500,
    loop: false,
    slidesToShow: 6,
    slidesToScroll: 4,
    arrows: true,
    swipeToSlide: false,
    centerMode: false,
    swipeEvent: () => {
      isCHangeChildCondition && setIschildrenSlide(false);
      setSlideParentSlide(true);
      // setTimeout(() => {
      //   setIschildrenSlide(true);
      //   setSlideParentSlide(false);
      // }, 3000);
      afterSlideChange()
    },
    afterChange: (e) => {
      // setIschildrenSlide(true);
      // setSlideParentSlide(false);
      afterSlideChange()
    },
    beforeChange: (current, next) => {
      handleNextDIsabled(initialOfferingData?.data?.properties?.length, next, 6);
      checkLoadMore(initialOfferingData?.data?.properties?.length, next, 6);
    },
    responsive: [
      {
        breakpoint: 2200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
          beforeChange: (current, next) => {
            handleNextDIsabled(initialOfferingData?.data?.properties?.length, next, 5);
            checkLoadMore(initialOfferingData?.data?.properties?.length, next, 5);
          },
        },
      },
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          beforeChange: (current, next) => {
            handleNextDIsabled(initialOfferingData?.data?.properties?.length, next, 4);
            checkLoadMore(initialOfferingData?.data?.properties?.length, next, 4);
          },
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          beforeChange: (current, next) => {
            handleNextDIsabled(initialOfferingData?.data?.properties?.length, next, 3);
            checkLoadMore(initialOfferingData?.data?.properties?.length, next, 3);
          },
        },
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          beforeChange: (current, next) => {
            handleNextDIsabled(initialOfferingData?.data?.properties?.length, next, 2);
            checkLoadMore(initialOfferingData?.data?.properties?.length, next, 2);
          },
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          beforeChange: (current, next) => {
            handleNextDIsabled(initialOfferingData?.data?.properties?.length, next, 2);
            checkLoadMore(initialOfferingData?.data?.properties?.length, next, 2);
          },
        },
      },
      {
        breakpoint: 639,
        settings: 'unslick',
      },
    ],
  };

  const insliderSecondary = {
    dots: false,
    infinite: false,
    speed: 500,
    loop: false,
    slidesToShow: 6,
    slidesToScroll: 4,
    arrows: true,
    swipeToSlide: false,
    centerMode: false,
    swipeEvent: () => {
      isCHangeChildCondition && setIschildrenSlide(false);
      setSlideParentSlide(true);
      setTimeout(() => {
        setIschildrenSlide(true);
        setSlideParentSlide(false);
      }, 3000);
    },
    afterChange: (e) => {
      setIschildrenSlide(true);
      setSlideParentSlide(false);
    },
    beforeChange: (current, next) => {
      handleNextDIsabled(secondaryMarketData?.data?.properties?.length, next, 6);
      checkLoadMore(secondaryMarketData?.data?.properties?.length, next, 6);
    },
    responsive: [
      {
        breakpoint: 2200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          beforeChange: (current, next) => {
            handleNextDIsabled(secondaryMarketData?.data?.properties?.length, next, 5);
            checkLoadMore(secondaryMarketData?.data?.properties?.length, next, 5);
          },
        },
      },
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          beforeChange: (current, next) => {
            handleNextDIsabled(secondaryMarketData?.data?.properties?.length, next, 4);
            checkLoadMore(secondaryMarketData?.data?.properties?.length, next, 4);
          },
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          beforeChange: (current, next) => {
            handleNextDIsabled(secondaryMarketData?.data?.properties?.length, next, 3);
            checkLoadMore(secondaryMarketData?.data?.properties?.length, next, 3);
          },
        },
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          beforeChange: (current, next) => {
            handleNextDIsabled(secondaryMarketData?.data?.properties?.length, next, 2);
            checkLoadMore(secondaryMarketData?.data?.properties?.length, next, 2);
          },
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          beforeChange: (current, next) => {
            handleNextDIsabled(secondaryMarketData?.data?.properties?.length, next, 2);
            checkLoadMore(secondaryMarketData?.data?.properties?.length, next, 2);
          },
        },
      },
      {
        breakpoint: 639,
        settings: 'unslick',
      },
    ],
  };

  const handleNotifyMe = async (value) => {
    setNotifyLoadingId(value?.id);
    await dispatch(
      notifyMeForProperty(
        Object.keys(userProfileData).length
          ? {
              propertyId: value?.id,
              forSecondary: value?.isSecondary,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNotifyLoadingId(0);
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
          : {
              propertyId: storeNotifyMeData?.id,
              forSecondary: storeNotifyMeData?.isSecondary,
              signUpForNewsletter: newsLetterChecked,
              email: value.email,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNotifyLoadingId(0);
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
      )
    );
  };

  const onFavouriteFailInitial = async (id) => {
    let updatedArray = initialOfferingData?.data?.properties?.map((item) => (item?.id === id ? { ...item, likedByUser: item?.likedByUser } : item));
    const newData = {
      ...initialOfferingData,
      data: {
        ...initialOfferingData?.data,
        properties: updatedArray,
      },
    };
    await dispatch(updateInitialPropertyList({ ...newData }));
  };

  const handleOnFavoriteClickInitial = async (propertyId) => {
    if (Object.keys(userProfileData).length > 0) {
      let updatedArray = initialOfferingData?.data?.properties?.map((item) => {
        if (item?.id === propertyId) {
          if (!item?.likedByUser) {
            dispatch(updateFavoriteCount());
          }
        }
        return item?.id === propertyId ? { ...item, likedByUser: !item?.likedByUser } : item;
      });
      const newData = {
        ...initialOfferingData,
        data: {
          ...initialOfferingData?.data,
          properties: updatedArray,
        },
      };
      await dispatch(updateInitialPropertyList({ ...newData }));
      await dispatch(
        addOrRemoveToFavouriteAction({
          propertyId,
          onFail: (id) => onFavouriteFailInitial(id),
        })
      );
    } else {
      navigate('/login');
    }
  };

  const onFavouriteFailSecondary = async (id) => {
    let updatedArray = secondaryMarketData?.data?.properties?.map((item) =>
      item?.propertyId === id ? { ...item, likedByLoggedInUser: item?.likedByLoggedInUser } : item
    );
    const newData = {
      ...secondaryMarketData,
      data: {
        ...secondaryMarketData?.data,
        properties: updatedArray,
      },
    };
    await dispatch(updateSecondaryPropertyList({ ...newData }));
  };

  const handleOnFavoriteClickSecondary = async (propertyId) => {
    if (Object.keys(userProfileData).length > 0) {
      let updatedArray = secondaryMarketData?.data?.properties?.map((item) => {
        if (item?.propertyId === propertyId) {
          if (!item?.likedByLoggedInUser) {
            dispatch(updateFavoriteCount());
          }
        }
        return item?.propertyId === propertyId ? { ...item, likedByLoggedInUser: !item?.likedByLoggedInUser } : item;
      });
      const newData = {
        ...secondaryMarketData,
        data: {
          ...secondaryMarketData?.data,
          properties: updatedArray,
        },
      };
      await dispatch(updateSecondaryPropertyList({ ...newData }));
      await dispatch(
        addOrRemoveToFavouriteAction({
          propertyId,
          onFail: (id) => onFavouriteFailSecondary(id),
        })
      );
    } else {
      navigate('/login');
    }
  };

  const featchSecondaryOfferingData = async () => {
    let response = await dispatch(fetchSecondaryOfferingListAction({ page: 1, perPage: 10 }));
    if (!response?.payload?.isError) {
      setOpenQuickBuySecondary();
    }
  };
  return (
    <div>
      {screenMD ? (
        <>
          <QuickBuyInitial
            quickBuyPropertyData={quickBuyPropertyData}
            open={openQuickBuy}
            modalState={setOpenQuickBuy}
            quickByOptions={quickByOptions}
            featchData={() => {
              quickByOptions?.featchInitialOfferingData();
              quickByOptions?.featchSecondaryOfferingData();
            }}
          />
          <TradeModal
            quickBuySecondaryOptions={quickBuySecondaryOptions}
            open={openQuickBuySecondary}
            modalState={setOpenQuickBuySecondary}
            quickBuyPropertyData={quickBuyPropertyData}
            isSingleTab={true}
            isSell={'1'}
            featchData={featchSecondaryOfferingData}
          />
        </>
      ) : (
        <>
          <QuickBuyInitialDrawer
            quickBuyPropertyData={quickBuyPropertyData}
            open={openQuickBuy}
            modalState={setOpenQuickBuy}
            quickByOptions={quickByOptions}
            featchData={() => quickByOptions?.featchInitialOfferingData()}
          />
          <TradeDrawer
            quickBuySecondaryOptions={quickBuySecondaryOptions}
            open={openQuickBuySecondary}
            modalState={setOpenQuickBuySecondary}
            quickBuyPropertyData={quickBuyPropertyData}
            isSingleTab={true}
            isSell={'1'}
            featchData={featchSecondaryOfferingData}
          />
        </>
      )}
      <div className='marketslider'>
        <div className='marketslider__container '>
          <div className='marketslider-header'>
            <div className='leftbar'>
              <h4 className='mb-0 text-almost-black'>{props.market}</h4>
            </div>
            <div className={`rightbar ${props.market === 'Realbricks Market' && 'secondary'}`}>
              <Button
                type='primary'
                className='market-filter-btn'
                onClick={() => navigate(props?.marketLink)}
              >
                Filter
              </Button>
              {isSecondary ? (
                <>
                  {!initialArrowHide && (
                    <>
                      <button disabled={prevDisabled} className='arrow prev-arrow' onClick={() => slider.current.slickPrev()}>
                        <ChevronLeft size={20} color={prevDisabled ? '#958B88' : '#1A1519'} />
                      </button>
                      <button disabled={nextDisabled} className='arrow next-arrow' onClick={() => slider.current.slickNext()}>
                        <ChevronRight size={20} color={nextDisabled ? '#958B88' : '#1A1519'} />
                      </button>
                    </>
                  )}
                </>
              ) : (
                <>
                  {!secondaryArrowHide && (
                    <>
                      <button disabled={prevDisabled} className='arrow prev-arrow' onClick={() => slider.current.slickPrev()}>
                        <ChevronLeft size={20} color={prevDisabled ? '#958B88' : '#1A1519'} />
                      </button>
                      <button disabled={nextDisabled} className='arrow next-arrow' onClick={() => slider.current.slickNext()}>
                        <ChevronRight size={20} color={nextDisabled ? '#958B88' : '#1A1519'} />
                      </button>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          {isSecondary ? (
            <div className='marketslider-wrap'>
              {secondaryMarketData?.data?.properties?.length > 0 ? (
                <div className='container-fluid'>
                  <Slider draggable={isParentSlid} ref={(c) => (slider.current = c)} {...insliderSecondary}>
                    {React.Children.toArray(
                      secondaryMarketData?.data?.properties?.map((item) => {
                        return (
                          <MarketSliderCard
                            id={item?.propertyId}
                            label={item?.label}
                            isSecondary={true}
                            showType={true}
                            cardType='Trading'
                            MarketBlockHead={item?.propertyName}
                            images={item?.images && Object.values(item?.images)}
                            Bids={item?.bids}
                            Asks={item?.asks}
                            LastPriceLabel='Last price'
                            LastPrice={`$ ${getUsCurrencyFormat(item?.lastTradedPrice)}`}
                            ShareDivLable='Est. Diviend Yield'
                            ShareDivValue={item?.dividendYield ?? 'NA'}
                            ShareDivTooltip={TOOLTIP_TEXT.ESTIMATED_DIVIDEND_YIELD}
                            NotAvailableTooltip='The Activity shows the number of bids and ask done for the property. Currently there is no data available for bids and asks.'
                            PrimaryButtonBuy={PRIMARY_BUTTON_BUY.includes(item?.label) && 'Buy now'}
                            isBuyDisabled={
                              item?.ownedEquity >= 9.8 || maxShareCalculator(item?.totalShare, item?.requestedShares, item?.ownedEquity) < 1 || props.isSecondaryMarketPaused
                            }
                            GhostNotify={GHOST_NOTIFY.includes(item?.label) && 'Notify me'}
                            LocationProperty={`${item?.cityName}, ${item?.stateName}`}
                            RentFamily={item?.propertyType}
                            isFavorite={item?.likedByLoggedInUser}
                            multiFamilyTotalUnit={item?.multiFamilyTotalUnit}
                            slideParentSlide={slideParentSlide}
                            BtnClick={() => {
                              setQuickBuyPropertyData(item);
                              quickBuySecondaryOptions.openForBuy();
                            }}
                            notifyMeBtnClick={(value) => {
                              Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
                            }}
                            notifyLoadingId={notifyLoadingId}
                            propertyType={item?.propertyType}
                            propertyTypeImage={item?.propertyTypeImage}
                            mouseEnter={() => setIsParentSlid(false)}
                            mouseLeave={() => setIsParentSlid(true)}
                            isChildrenSlide={isChildrenSlide}
                            mouseDownEvent={() => {
                              setIsChangeChildCondition(false);
                              setIschildrenSlide(true);
                            }}
                            mouseUpEvent={() => setIsChangeChildCondition(true)}
                            onFavoriteClick={() => handleOnFavoriteClickSecondary(item?.propertyId)}
                            isSecondaryMarketPaused={props.isSecondaryMarketPaused}
                          />
                        );
                      })
                    )}
                  </Slider>
                </div>
              ) : (
                <>
                  <div className='container-fluid'>
                    <Spin spinning={secondaryLoading} />
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className='marketslider-wrap'>
              {initialOfferingData?.data?.properties?.length > 0 ? (
                <div className='container-fluid'>
                  <Slider draggable={isParentSlid} ref={(c) => (slider.current = c)} {...inslider}>
                    {React.Children.toArray(
                      initialOfferingData?.data?.properties?.map((item) => {
                        return (
                          <MarketSliderCard
                            id={item?.id}
                            label={item?.label}
                            multiFamilyTotalUnit={item?.multiFamilyTotalUnit}
                            isSecondary={false}
                            showType={true}
                            cardType='Initial Offering'
                            MarketBlockHead={item?.name}
                            images={item?.images && Object.values(item?.images)}
                            RemainShareLable={`Shares remaining`}
                            RemainShares={item?.sharesRemaining}
                            EstimatedDividendYieLable='Estimated Dividend Yield'
                            EstimatedDividendYield={item?.dividendYield}
                            ShareInvestorLabel='Investors'
                            ShareInvestor={item?.investors}
                            isBuyDisabled={
                              item?.percentageFunded >= 100 ||
                              maxShareCalculatorWithNoOfShare(Number(item.totalShares), 0, Number(item.userPurchasedShares)) < 1
                            }
                            duration={item.duration}
                            PrimaryButtonBuy={PRIMARY_BUTTON_BUY.includes(item?.label) && 'Buy now'}
                            GhostNotify={GHOST_NOTIFY.includes(item?.label) && 'Notify me'}
                            ProgressPercent={item?.percentageFunded?.toString()}
                            LocationProperty={`${item?.city}, ${item?.state}`}
                            RentFamily={item?.state}
                            MinimumnSharesLabel={PRIMARY_PROPERTY_LABELS.SHARE_PRICE}
                            MinimumnShares={`${'$' + item?.perSharePrice}`}
                            propertyType={item?.propertyType}
                            isFavorite={item?.likedByUser}
                            propertyTypeImage={item?.propertyTypeImage}
                            slideParentSlide={slideParentSlide}
                            BtnClick={() => {
                              setQuickBuyPropertyData(item);
                              setOpenQuickBuy('StepOne');
                            }}
                            notifyMeBtnClick={(value) => {
                              Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
                            }}
                            notifyLoadingId={notifyLoadingId}
                            mouseEnter={() => setIsParentSlid(false)}
                            mouseLeave={() => setIsParentSlid(true)}
                            isChildrenSlide={isChildrenSlide}
                            mouseDownEvent={() => {
                              setIsChangeChildCondition(false);
                              setIschildrenSlide(true);
                            }}
                            mouseUpEvent={() => setIsChangeChildCondition(true)}
                            onFavoriteClick={() => handleOnFavoriteClickInitial(item?.id)}
                          />
                        );
                      })
                    )}
                  </Slider>
                </div>
              ) : (
                <div className='container-fluid'>
                  <Spin spinning={initialLoading} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <NotifyMeModal
        open={open}
        setOpen={setOpen}
        email={email}
        setEmail={setEmail}
        newsLetterChecked={newsLetterChecked}
        setNewsLetterChecked={setNewsLetterChecked}
        handleNotifyMe={handleNotifyMe}
        ref={formRef}
      />
    </div>
  );
};

MarketSlider.propTypes = {
  initialOfferingData: PropTypes.object,
  secondaryMarketData: PropTypes.object,
  initialLoading: PropTypes.bool,
  isSecondary: PropTypes.bool,
  secondaryLoading: PropTypes.bool,
  market: PropTypes.string,
  marketLink: PropTypes.string,
  isSecondaryMarketPaused: PropTypes.bool,
  onLoadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
};

export default MarketSlider;
